export const BOOK_LANGUAGE_METADATA = {
  1: {
    arabicTitle: "مدرسة علما المتوسطة",
    arabicDescription: "وثائق وسجلات تتعلق بمدرسة علما المتوسطة وتاريخها التربوي.",
    englishPdfUrl: "/books/pdfs/english/alma-mid-school-english.pdf",
  },
  2: {
    arabicTitle: "ملحمة العيشية - نسخة مختصرة",
    arabicDescription: "نسخة مختصرة من ملحمة العيشية وتاريخ البلدة وأهلها.",
    englishPdfUrl: "/books/pdfs/english/aychieh-epic-one-page-excerpt-english.pdf",
  },
  3: {
    arabicTitle: "ملحمة العيشية",
    arabicDescription: "الملحمة الكاملة عن تاريخ بلدة العيشية وتراثها وأهلها.",
    englishPdfUrl: "/books/pdfs/english/aychieh-epic-english.pdf",
  },
  4: {
    arabicTitle: "من مختارات الخوري بولس عنيد",
    arabicDescription: "مجموعة من كتابات ومختارات الخوري بولس عنيد.",
    englishPdfUrl: "/books/pdfs/english/from-the-library-of-abouna-boulos-english.pdf",
  },
  5: {
    arabicTitle: "تعرّف على العيشية",
    arabicDescription: "تعريف بتاريخ بلدة العيشية وتراثها ومجتمعها.",
    englishPdfUrl: "/books/pdfs/english/get-to-know-aichieh-english.pdf",
  },
  6: {
    arabicTitle: "اليوبيل الذهبي للسيامة الكهنوتية",
    arabicDescription: "كتاب تذكاري بمناسبة اليوبيل الذهبي للسيامة الكهنوتية.",
    englishPdfUrl: "/books/pdfs/english/golden-jubilee-priestly-ordination-english.pdf",
  },
  7: {
    arabicTitle: "إلهامات للعظات",
    arabicDescription: "تأملات وأفكار روحية تساعد في إعداد العظات والتعليم الديني.",
    englishPdfUrl: "/books/pdfs/english/inspirations-for-homilies-english.pdf",
  },
  8: {
    arabicTitle: "كتاب المراثي",
    arabicDescription: "قصائد وتأملات في الحزن والفقد والرجاء المسيحي.",
    englishPdfUrl: "/books/pdfs/english/lamentation-english.pdf",
  },
  9: {
    arabicTitle: "مذكّرات العمر - مجلّد أول",
    arabicDescription: "مجموعة شخصية من الشعر والذكريات وتأملات العمر.",
    englishPdfUrl: "/books/pdfs/english/my-poems-english.pdf",
  },
  10: {
    arabicTitle: "تاريخ آل عنيد في العيشية",
    arabicDescription: "تاريخ عائلة عنيد وجذورها وإرثها في بلدة العيشية.",
    englishPdfUrl: "/books/pdfs/english/oneid-family-history-english.pdf",
  },
  11: {
    arabicTitle: "النفحات الشعرية",
    arabicDescription: "قصائد ونفحات شعرية في الإيمان والحياة والرجاء.",
    englishPdfUrl: "/books/pdfs/english/poetic-inspirations-english.pdf",
  },
  12: {
    arabicTitle: "عظات روحية",
    arabicDescription: "مجموعة عظات وتأملات في الإنجيل والحياة الروحية.",
    englishPdfUrl: "/books/pdfs/english/sermons-english.pdf",
  },
  13: {
    arabicTitle: "النفحات الروحية",
    arabicDescription: "إرشادات وتأملات روحية للحياة اليومية.",
    englishPdfUrl: "/books/pdfs/english/spiritual-inspirations-english.pdf",
  },
  14: {
    arabicTitle: "مقالات إنجيلية 2006",
    arabicDescription: "مقالات وتأملات إنجيلية جُمعت ونُسّقت سنة 2006.",
    englishPdfUrl: "/books/pdfs/english/st-charbel-articles-2006-english.pdf",
  },
  15: {
    arabicTitle: "مراحل درب الصليب",
    arabicDescription: "صلوات وتأملات في مراحل درب الصليب.",
    englishPdfUrl: "/books/pdfs/english/the-way-of-the-cross-english.pdf",
  },
};

export function withLanguageMetadata(book) {
  const metadata = BOOK_LANGUAGE_METADATA[Number(book.id)] || {};
  return {
    ...book,
    ...metadata,
    arabicPdfUrl: book.arabic_pdf_url || book.pdf_url || null,
    englishPdfUrl: book.english_pdf_url || metadata.englishPdfUrl || null,
  };
}
